// extracted by mini-css-extract-plugin
export var buttonRow = "checkoutModal-module--buttonRow--5a158";
export var buttonWrapper = "checkoutModal-module--buttonWrapper--e9a85";
export var centeredViewHeading = "checkoutModal-module--centeredViewHeading--0b669";
export var centeredViewMessage = "checkoutModal-module--centeredViewMessage--2a612";
export var centeredViewWrapper = "checkoutModal-module--centeredViewWrapper--66fa9";
export var excelIcon = "checkoutModal-module--excelIcon--c679d";
export var modalBodyWrapper = "checkoutModal-module--modalBodyWrapper--6ded0";
export var modalMessageWrapper = "checkoutModal-module--modalMessageWrapper--82697";
export var smallBodyWrapper = "checkoutModal-module--smallBodyWrapper--9ba86";